export function TypingIndicator() {
  return (
    <div className="cw-typing" role="status" aria-live="polite" aria-label="V0 rédige">
      <span className="cw-typing__dot" />
      <span className="cw-typing__dot" />
      <span className="cw-typing__dot" />
    </div>
  );
}
